export default {
  container: 'modal',
  form: 'standard'
}



// WEBPACK FOOTER //
// ./src/config/ui.js